<div fxLayout="column" fxLayoutAlign="start center" class="message">
  <h3>This evaluation is closed.</h3>
</div>
